
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey-and-valuation-fee",
      function () {
        return require("private-next-pages/survey-and-valuation-fee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey-and-valuation-fee"])
      });
    }
  